export default __webpack_public_path__ + "static/alfred_init-6bf513178ece341c1c0566a473effdb2.png";